export * from './heroBanner.variants.defaults';
